import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NzNotificationService} from "ng-zorro-antd/notification";
import {TranslocoService} from "@ngneat/transloco";

export enum FileType {
  IMAGES,
  VIDEOS,
  DOCS,
  YOUTUBE
}

@Component({
  selector: 'app-embedded-file-viewer',
  templateUrl: './embedded-file-viewer.component.html',
  styleUrls: ['./embedded-file-viewer.component.scss']
})
export class EmbeddedFileViewerComponent implements OnInit {
  FileType = FileType;
  fileUrl = '';
  fileType?: FileType;
  supportedImageTypes = ['.jpg', '.jpeg', '.png'];
  supportedVideoTypes = ['.mp4'];
  supportedDocTypes = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.pdf'];
  isFileNotSupport = false;
  intervalId = 0;
  fileUrlTmp = '';
  isDocument = false;
  count = 0;
  constructor(
    private route: ActivatedRoute,
    private notificationService: NzNotificationService,
    private translocoService: TranslocoService,
  ) { }

  ngOnInit(): void {
    const url = this.route.snapshot.queryParamMap.get('url') || '';
    if (this.supportedImageTypes.some((value) => url.toLowerCase().includes(value))) {
      this.fileType = FileType.IMAGES;
      this.fileUrl = url;
    } else if (this.supportedVideoTypes.some((value) => url.toLowerCase().includes(value))) {
      this.fileType = FileType.VIDEOS;
      this.fileUrl = url;
    } else if (url.includes('www.youtube.com')) {
      this.fileType = FileType.YOUTUBE;
      this.fileUrl = url;
    } else if (this.supportedDocTypes.some((value) => url.toLowerCase().includes(value))) {
      this.fileType = FileType.DOCS;
      this.fileUrl = `https://docs.google.com/viewer?url=${url}&embedded=true`;
      this.fileUrlTmp = this.fileUrl;
    } else {
      try {
        this.fileUrl = new URL(url).href;
        this.isDocument = true;
      } catch (err) {
        this.isDocument = false;
        this.isFileNotSupport = true;
      }
    }
  }

  loadedIframe(event: any) {
    if (event.target.src === '' && this.fileType === FileType.DOCS) {
      this.intervalId = window.setInterval(this.reloadIframe.bind(this), 3000);
    }

    if (event.target.src !== '' && this.fileType === FileType.DOCS) {
      clearInterval(this.intervalId);
    }
  }

  reloadIframe() {
    this.count++;
    this.fileUrl = `${this.fileUrlTmp}&id=${(new Date()).getTime()}`;
    if(this.count === 10) {
      clearInterval(this.intervalId);
      this.notificationService.error(
        '',
        this.translocoService.translate('common.failed')
      );
    }
  }
}
